﻿import { defineJQueryPlugin } from '../../../../node_modules/bootstrap/js/src/util/index'
import EventHandler from '../../../../node_modules/bootstrap/js/src/dom/event-handler'
import SelectorEngine from '../../../../node_modules/bootstrap/js/src/dom/selector-engine'
import BaseComponent from '../../../../node_modules/bootstrap/js/src/base-component'

const NAME = 'imageslider'
const DATA_KEY = 'bs.imageslider'
const EVENT_KEY = `.${DATA_KEY}`
const DATA_API_KEY = '.data-api'

const EVENT_LOAD_DATA_API = `load${EVENT_KEY}${DATA_API_KEY}`

const SELECTOR_DATA_TOGGLE = '[data-image-slider]'

class ImageSlider extends BaseComponent {
    constructor(element, config) {
        super(element, config)

        const input = SelectorEngine.findOne(".slider", element);

        EventHandler.on(input, 'input', (event) => {
            element.style.setProperty('--position', `${event.target.value}%`);
        });
    }

    // Getters
    static get NAME() {
        return NAME;
    }
}

/**
 * Data API implementation
 */

EventHandler.on(window, EVENT_LOAD_DATA_API, () => {
    const imageSliders = SelectorEngine.find(SELECTOR_DATA_TOGGLE)

    for (const imageSlider of imageSliders) {
        ImageSlider.getOrCreateInstance(imageSlider)
    }
})

/**
 * jQuery
 */

defineJQueryPlugin(ImageSlider)

export default ImageSlider